import ApiBase from '@/api/api-base'
import {ACTIVE_BASE_REST} from '@/api/constants'

export default class Attachment extends ApiBase {
  constructor (store) {
    const path = ACTIVE_BASE_REST + '/attachment'
    super(store, path)
  }

  delete(payload, showProgress) {
    return this._request({
      method: 'DELETE',
      body: payload,
      showProgress
    })
  }
}